<template>
  <div>
    <!-- Title -->
    <div class="content">
      <h2 class="subtitle">Obustave</h2>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi mjesec</a>
        </li>
      </ul>
    </div>

    <!-- Time Span -->
    <div class="content">
      <date-picker
        v-model="time3"
        @input="monthChosen"
        type="month"
      ></date-picker>
    </div>

    <!-- Tabs -->
    <div class="tabs is-centered is-medium no-print">
      <ul>
        <li :class="{ 'is-active': true }">
          <a>Izaberi Sektor</a>
        </li>
      </ul>
    </div>

    <!-- Sektor -->
    <div slot="content">
      <div>
        <div class="field">
          <label class="label no-print">Sektor</label>
          <div class="control">
            <vue-select
              class="has-background-info-light"
              @option:selected="departmentSelected"
              type="text"
              label="name"
              :clearable="false"
              :options="departments"
              v-model="seletedDepartment"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="base-demo">
      <vue-table-dynamic
        class="small"
        :params="params"
        @cell-click="tableCellClicked"
      ></vue-table-dynamic>
    </div>
  </div>
</template>

<script>
import ReportService from "../../services/report.service";
import VueTableDynamic from "vue-table-dynamic";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

const colors = [
  "#363636",
  "#046FDB",
  "#F85252",
  "#8B54E4",
  "#F07B3B",
  "#3ba272",
  "#c1ffa3",
];

export default {
  name: "Obusta",
  components: {
    VueTableDynamic,
    DatePicker,
  },
  data() {
    return {
      //   monthChosen
      time3: null,
      selectedMonth: 0,
      selectedYear: 0,
      employees: [],
      params: {
        data: [
          [
            "n",
            "Ime i prezime",
            "Prek. sati",
            "Stimulans na prekovremeno",
            "Ekstra stimulans",
            "Mobilni telefoni",
            "Kasko",
            "Manjak na teret rada",
            "Roba na rate",
            "Akontacija",
            "Kazna",
            "Manjak magacina",
            "Kaš.",
            "Pr. brz.",
            " ",
          ],
        ],
        header: "row",
        enableSearch: true,
        border: true,
        stripe: true,
        columnWidth: [
          { column: 0, width: 30 },
          { column: 2, width: 80 },
          { column: 3, width: 100 },
          { column: 4, width: 100 },
          { column: 5, width: 100 },
          { column: 6, width: 100 },
          { column: 7, width: 100 },
          { column: 8, width: 100 },
          { column: 9, width: 100 },
          { column: 10, width: 100 },
          { column: 11, width: 100 },
          { column: 12, width: 60 },
          { column: 13, width: 60 },
          { column: 14, width: 100 },
        ],
        wordWrap: "break-word",
        whiteSpace: "normal",
        // highlight: { column: [-1], row: [-1] },
        highlightedColor: colors[6],
      },
      departments: [],
      seletedDepartment: null,
      average: null,
      activeDays: 0,
      averagePerDay: null,
    };
  },

  mounted() {
    this.time3 = new Date();
    this.monthChosen(this.time3);
  },

  methods: {
    tableCellClicked() {},

    resetUi() {
      this.params.data = [
        [
          "n",
          "Ime i prezime",
          "Prek. sati",
          "Stimulans na prekovremeno",
          "Ekstra stimulans",
          "Mobilni telefoni",
          "Kasko",
          "Manjak na teret rada",
          "Roba na rate",
          "Akontacija",
          "Kazna",
          "Manjak magacina",
          "Kaš.",
          "Pr. brz.",
          " ",
        ],
      ];
      this.dailyLogs = [];
    },

    monthChosen(mnth) {
      console.log(mnth);
      this.selectedMonth = mnth.getMonth() + 1;
      this.selectedYear = mnth.getFullYear();
      console.log(this.selectedMonth);
      console.log(this.selectedYear);
      this.getDepartments();
      this.seletedDepartment = null;
      this.resetUi();
    },

    getDepartments() {
      ReportService.GetAllDepartmentsOfMyCompanyHistoricallyByMonth(
        this.selectedMonth,
        this.selectedYear
      ).then((response) => {
        // reset ui
        this.departments = [];
        this.departmentData = response.data;
        this.arrangeSectors(response.data);
      });
    },

    arrangeSectors(data) {
      data.forEach((element) => {
        this.departments.push({
          name: element.name,
          id: element.departmentId,
        });
      });
      // console.log(this.departments);
    },

    getData(departmentId, month, year) {
      console.log("getData");
      this.pushData(departmentId, month, year);
    },

    pushData() {
      let ndx = 1;

      console.log(this.employees);

      this.employees.forEach((emp) => {
        this.params.data.push([
          ndx++,
          emp.firstName + " " + emp.lastName,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ]);
      });
    },

    async departmentSelected() {
      this.resetUi();

      let departmentId = this.seletedDepartment.id;

      console.log("department data: ", this.departmentData);

      this.employees = [];

      this.departmentData.forEach((dep) => {
        if (dep.departmentId === departmentId) {
          dep.employee.forEach((emp) => {
            if (emp.status) {
              this.employees.push(emp);
            }
          });
        }
      });

      this.getData(departmentId, this.selectedMonth, this.selectedYear);
    },
  },
};
</script>

<style scoped>
.base-demo {
  width: 1550px;
  white-space: nowrap;
}

.small {
  font-size: 10px;
}

.base-demo >>> .v-table-row.is-header {
  /* background: red !important; */
  /* border-top: 1px solid red !important; */
  /* border-right: 1px solid red !important; */
  border-bottom: 1px solid red !important;
}
.base-demo >>> .table-cell {
  /* border-left: 1px solid red !important; */
  padding: 1px !important;
  /* flex: 0 0 30px !important; */
}
.base-demo >>> .table-cell-content {
  /* border-left: 1px solid red !important; */
  /* margin: 0px -10px 0px -10px !important; */
  padding: 0px !important;
  /* flex: 0 0 0 0px !important; */
}
</style>
